import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import {
    ServiceCertificateInput,
} from '@libs/types/src/services/input-type/services/service-certificate.input';
import { OkObject } from '@it2go/types';
import {
    ServiceCertificateCreateInput,
} from '@libs/types/src/services/input-type/services/service-certificate.create-input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import { serviceCertificateItemFrag } from './types/service-settings.types';
import { ServiceCertificateGridObject } from '@libs/types/src/services/object-type/service/service-certificate.object';

@Injectable({ providedIn: 'root' })
export class ServiceCertificatesGqlService extends GqlServiceV2 {

    public createServiceCertificate(input: ServiceCertificateCreateInput): Promise<OkObject> {
        return this.mutate(
            `
                mutation($input: ServiceCertificateCreateInput!) {
                    serviceCertificate {
                        create(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async getServiceCertificates(input: GridInput, frag: string = serviceCertificateItemFrag) {
        return this.query<ServiceCertificateGridObject>(
            `
                query($input: GridInput!) {
                    serviceCertificate {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public hasServiceCertificate(input: ServiceCertificateInput): Promise<OkObject> {
        return this.query(
            `
                query($input: ServiceCertificateInput!) {
                    serviceCertificate {
                        hasCertificate(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteServiceCertificate(input: IdInput): Promise<OkObject> {
        return this.mutate(
            `
                mutation($input: IdInput!) {
                    serviceCertificate {
                        delete(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

}
